// extracted by mini-css-extract-plugin
export default {"wrapper":"QuizConfig_wrapper__uaEpF","section":"QuizConfig_section__Xqyyl","moving-border":"QuizConfig_moving-border__juU7o","rotate":"QuizConfig_rotate__k7W7S"};